<template>
    <v-sheet height="100%" class="d-flex flex-column" style="overflow: hidden">
        <v-layout column justify-center align-center fill-height style="overflow: auto">
            <i class="icon icon-check"></i>
            <h3 class="tit mt-16 mt-lg-24 mb-8 mb-lg-16">회원가입이 완료 되었습니다.</h3>
            <p class="page-text--lg">
                관리자 승인 후 기업서비스를 이용하실 수 있습니다<br />
                1~2 영업일 이내에 승인여부를 확인 하실 수 있습니다
            </p>
        </v-layout>
        <div class="v-btn-group">
            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('close')"><span class="grey-6--text">이전 화면으로 돌아가기</span></v-btn>
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="$emit('next')"><span>대시보드로 가기</span></v-btn>
        </div>
    </v-sheet>
</template>

<script>
export default {};
</script>

<style>
</style>